import React from "react";

const GreenBox = ({
  dashBoardData,
  marketName,
  query,
  currSymbol,
  avgData,
  unitType,
  rate,
  currency,
  onChangeUnit,
  onChangeRate,
  handleCurrencyChange,
  currData,
  getAvgPrice,
}) => {
  return (
    <div className="green-box">
      <h1
        className={`m-0 table-heading rightmar ${
          dashBoardData?.data?.length === 0 ? "t-center" : "t-left"
        }`}
      >
        {`${
          marketName === null || marketName === undefined ? query : marketName
        }`}
      </h1>
      <div className="avg-drops">
        <div className="avg-data">
          <div className="avg-price">
            <span>{currSymbol}</span>
            {avgData
              ? avgData?.previousYearAvgPrice
                ? getAvgPrice(avgData?.previousYearAvgPrice)
                : "N/A"
              : ""}
          </div>
          <div className="avg-month-text">12-month average</div>
          <div className="avg-last-month">
            Last month:{" "}
            <span>{`${currSymbol}${getAvgPrice(
              avgData?.previousMonthAvgPrice
            )}`}</span>
          </div>
        </div>
        <div className="drops-data">
          <div className="drops-all">
            <div className="drop-box">
              <div className="drop-label">Unit Type:</div>
              <select
                className="drop-select"
                value={unitType}
                onChange={onChangeUnit}
              >
                <option value="SF">Studio</option>
                <option value="1F">1 Bedroom</option>
                <option value="2F">2 Bedroom</option>
                <option value="3F">3 Bedroom</option>
              </select>
            </div>
            <div className="drop-box">
              <div className="drop-label">Price Rate:</div>
              <select
                className="drop-select"
                value={rate}
                onChange={onChangeRate}
              >
                <option value="daily">Nightly</option>
                <option value="monthly">Monthly</option>
              </select>
            </div>
            <div className="drop-box">
              <div className="drop-label">Currency:</div>
              <div className="curr-visible">{currency}</div>
              <select
                className="drop-select"
                value={currency}
                onChange={handleCurrencyChange}
                style={{ maxWidth: 120 }}
              >
                {currData?.currencies?.map((item, index) => {
                  return (
                    <option key={index} value={item.currencyName}>
                      {item.currencyName}
                      {" - "}
                      {item.currencyDescription}
                    </option>
                  );
                })}
              </select>
            </div>
          </div>
          <div className="lows-highs">
            <div className="lh">
              <span>Low </span>price average:{" "}
              <span className="bold">{`${currSymbol}${getAvgPrice(
                avgData?.previousYearMinAvgPrice
              )}`}</span>
            </div>
            <div className="lh">
              <span>High </span>price average:{" "}
              <span className="bold">{`${currSymbol}${getAvgPrice(
                avgData?.previousYearMaxAvgPrice
              )}`}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default GreenBox;
